import React from 'react';
import { TFunction } from 'i18next';
import { DocumentationValidationStatusEnum } from 'graphql-common';
import Button, { ButtonTypes } from '@lib/components/Button/Button';
import ButtonWithDropDown from '@lib/components/ButtonWithDropDown/ButtonWithDropDown';
import Chip, { ChipSizes } from '@lib/components/Chip/Chip';
import { NavItemTypeEnum } from '@lib/components/Menu/Menu';
import { materialSymbolsOutlined } from '@lib/enums/common';
import getValidationStatusChipType from '@lib/utils/documentation/getValidationStatusChipType';
import getValidationStatusOptions from '@lib/utils/documentation/getValidationStatusOptions';

type Args = {
  isApprovals?: boolean;
  isViewLocked?: boolean;
  isViewOnly?: boolean;
  onBulkEdit: () => void;
  onDelete: () => void;
  onStatusBulkChangeHandler: (
    status: DocumentationValidationStatusEnum,
  ) => void;
  selectedItemsCount?: number;
  t: TFunction<'translation', undefined>;
};

export default function getTableActionsForSelected(args: Args) {
  const {
    isApprovals,
    isViewLocked,
    isViewOnly,
    onBulkEdit,
    onDelete,
    onStatusBulkChangeHandler,
    selectedItemsCount = 0,
    t,
  } = args;

  if (isViewOnly) return [];

  if (isApprovals) {
    const chipLeftIcon = (statusItem: DocumentationValidationStatusEnum) => (
      <Chip
        leftIcon="circle"
        type={getValidationStatusChipType(statusItem)}
        size={ChipSizes.smallLeftIconOnly}
      />
    );
    const options = getValidationStatusOptions();
    return [
      <ButtonWithDropDown
        key="change-status"
        popoverProps={{ width: 180 }}
        buttonProps={{
          buttonText: `${t('change-status')} (${selectedItemsCount})`,
          buttonType: ButtonTypes.primaryOutlined,
        }}
        navItems={options.map(({ value, labelKey }) => ({
          id: value,
          title: t(labelKey),
          onClick: () => onStatusBulkChangeHandler(value),
          type: NavItemTypeEnum.Secondary,
          leftIcon: () => chipLeftIcon(value),
        }))}
      />,
    ];
  }

  if (isViewLocked) {
    return [
      <Button
        key="delete"
        buttonText={`${t('delete')} (${selectedItemsCount})`}
        buttonType={ButtonTypes.negativeOutlined}
        leftIcon="delete"
        leftIconClassName={materialSymbolsOutlined}
        onClick={onDelete}
      />,
    ];
  }

  return [
    <Button
      key="bulk-edit"
      buttonText={`${t('bulk-edit')} (${selectedItemsCount})`}
      buttonType={ButtonTypes.primaryOutlined}
      leftIcon="edit"
      leftIconClassName={materialSymbolsOutlined}
      onClick={onBulkEdit}
    />,
    <Button
      key="delete"
      buttonText={`${t('delete')} (${selectedItemsCount})`}
      buttonType={ButtonTypes.negativeOutlined}
      leftIcon="delete"
      leftIconClassName={materialSymbolsOutlined}
      onClick={onDelete}
    />,
  ];
}
